import React from "react";

const BudgetTable = ({ data }) => {
  const grouped = Object.values(
    (data || []).reduce((acc, item) => {
      const key = item?.account_dashboard_rename ?? "Unknown";

      acc[key] = acc[key] || {
        account_dashboard_rename: key,
        total_budget: 0,
        spent: 0,
        left_to_spend: 0,
      };

      acc[key].total_budget += Number(item?.total_budget) || 0;
      acc[key].spent += Number(item?.spent) || 0;
      acc[key].left_to_spend += Number(item?.left_to_spend) || 0;

      return acc;
    }, {})
  );

  // Calculate total row
  const totalRow = grouped
    .sort((a, b) => b.total_budget - a.total_budget)
    .reduce(
      (totals, row) => {
        totals.total_budget += row.total_budget;
        totals.spent += row.spent;
        totals.left_to_spend += row.left_to_spend;
        return totals;
      },
      {
        total_budget: 0,
        spent: 0,
        left_to_spend: 0,
      }
    );

  return (
    <div className="revenueTableContainer">
      <table className="revenueTable">
        <thead>
          <tr>
            <th>Account</th>
            <th>Total Budget</th>
            <th>Spent</th>
            <th>Difference</th>
          </tr>
        </thead>
        <tbody>
          {grouped.map((row, index) => (
            <tr key={index}>
              <td>{row.account_dashboard_rename}</td>
              <td>
                {/* $
                {row.total_budget.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} */}

                {row.total_budget >= 0
                  ? `$${row.total_budget.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : `($${Math.abs(row.total_budget).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })})`}
              </td>
              <td>
                {/* $
                {row.spent.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })} */}

                {row.spent >= 0
                  ? `$${row.spent.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : `($${Math.abs(row.spent).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })})`}
              </td>
              <td
                style={{
                  color: row.left_to_spend >= 0 ? "green" : "red",
                }}
              >
                {row.left_to_spend >= 0
                  ? `$${row.left_to_spend.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : `($${Math.abs(row.left_to_spend).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })})`}
              </td>
            </tr>
          ))}

          {/* Total row */}
          <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
            <td>Total</td>
            <td>
              $
              {totalRow.total_budget.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </td>
            <td>
              $
              {totalRow.spent.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </td>
            <td
              style={{
                color: totalRow.left_to_spend >= 0 ? "green" : "red",
              }}
            >
              {totalRow.left_to_spend >= 0
                ? `$${totalRow.left_to_spend.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                : `($${Math.abs(totalRow.left_to_spend).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )})`}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default BudgetTable;
